export const formatService = (service) => {
    return {
        code: service.service_code,
        fee: service.cost,
        name: service.long_descrip ?? service.name,
        serviceCodeId: service.service_code_id,
    };
};
